import {UUID} from '@/plugins/common'
import Node from './node'
import Connection from './connection'
import _ from 'lodash'

export default class Process {
  id = ''
  // 定义 ID
  definitionId = ''
  // 版本号d
  version = null

  // 表单外部id
    formId = ''
  // 开始节点
  startNode = ''
  // 标题
  title = ''
  // 节点集合
  nodes = []
  // 连接线
  connections = []
  // 属性
  attribute = {}

  constructor (args = {}) {
    _.merge(this, args)
  }

  static create (args) {
    if (!args.definitionId) {
      throw new Error(`缺少定义 ID 无法创建相应流程版本.`)
    }
    args.id = '_' + UUID.create()
    args.version = 1
    args.title = ''
    args.attribute = {
      // 节点交互
      interactions: [],
      // 流程表单暂存
      temporaryStorageEnable: false,
      // 流程标题
      processTitle: '',
      // 中途归档开关
      allNodeArchiveEnable: true,
      // 中途归档节点数据
      nodeArchive: []
    }
    let process = new Process(args)
    // 开始节点
    let startNode = Node.createStartNode({
      'name': '发起流程',
      'type': 'userTask',
      'processId': process.id,
      'position': {'x': 10, 'y': 0}
    })
    process.nodes.push(startNode)
    process.startNode = startNode.id
    // 结束节点
    let endNode = Node.create({'name': '结束节点', 'type': 'endEvent', 'processId': process.id})
    process.nodes.push(endNode)
    // 终止节点
    process.nodes.push(Node.create({'name': '终止节点', 'type': 'cancelEvent', 'processId': process.id}))

    // 处理连接线, 发起节点比较特殊, 不需要处理源节点的连接线, 所以在这个地方单独处理
    process.addConnection(startNode, endNode, true, '')
    return process
  }

  static load (args) {
    args.version++
    args.id = '_' + UUID.create()
    let process = new Process(args)
    if (args.nodes) {
      let nodes = []
      args.nodes.forEach(m => {
        nodes.push(Node.load(m))
      })
      process.nodes = nodes
    }
    if (args.connections) {
      let connections = []
      args.connections.forEach(m => {
        connections.push(Connection.load(m))
      })
      process.connections = connections
    }
    if (args.attribute) {
      args.attribute.interactions.forEach(item => {
        if (item.triggerConnections) {
          item.triggerConnections = item.triggerConnections.split(',')
        }
      })
      process.attribute = args.attribute
    }
    return process
  }

  get endNode () {
    return this.nodes.find(m => m.type === 'endEvent')
  }

  // 增加节点
  addNode (args) {
    let nodes = this.getAllNodes()
    args.name = `${args.name}${nodes.filter(m => m.type === args.type).length + 1}`
    let node = Node.create(args)

    this.nodes.push(node)

    // 按照 y 降序排序
    let orderNode = _.orderBy(nodes, ['position.y'], ['desc'])
    // 找出当前节点之上的节点
    orderNode = orderNode.filter(m => m.position.y < node.position.y)
    let sourceNode
    for (let i = 0; i < orderNode.length; i++) {
      if (!sourceNode) {
        sourceNode = orderNode[0]
      } else if (sourceNode && sourceNode.position.y > orderNode[0].position.y) {
        break
      } else if (Math.abs(sourceNode.position.x - node.position.x) > Math.abs(orderNode[0].position.x - node.position.x)) {
        sourceNode = orderNode[0]
      }
    }
    if (!sourceNode) {
      console.warn('无法寻找源节点')
    } else {
      let endNode = this.endNode
      // 寻找源节点的默认线是结束节点的线
      let sourceConnection = this.connections.find(m => m.sourceNodeId === sourceNode.id && m.targetNodeId === endNode.id && m.defaultLine)
      if (sourceConnection) {
        // 如果找到了, 将源节点的默认线指向改为当前节点
        sourceConnection.targetNodeId = node.id
        // 将源节点的下一节点的通知节点人改为当前节点
        sourceConnection.notice.forEach(a => {
          a.targetNode = [node.id]
        })
        sourceConnection.operationType = 'normal'
        // 如果在网关下第一次拖个节点，需要再增加一条和默认线一样的线，（对网关特殊处理）
        if (sourceNode.type === 'inclusiveGateway_start') {
          this.addConnection(sourceNode, node)
        }
      } else {
        this.addConnection(sourceNode, node)
      }
      this.addConnection(node, endNode, true)
    }

    // 返回值为了在processService.js调用该方法时能够拿到node中的formId
    return node
  }

  // 修改节点位置信息
  updatePosition (args) {
    let node = this.nodes.find(m => m.id === args.id)
    node.position.x = args.x
    node.position.y = args.y
  }

  /**
   *  增加连接连接线
   * @param sourceNode 源节点
   * @param targetNode 目标节点
   * @param operationType 操作类型
   * @param flag 是否默认线
   */
  addConnection (sourceNode, targetNode, flag, operationType) {
    // 当前节点增加一条指向结束节点的默认线
    switch (targetNode.type) {
      case 'cancelEvent':
        operationType = 'cancelEvent'
        break
      case 'endEvent':
        operationType = 'endEvent'
        break
      default :
        operationType = 'normal'
    }
    flag = flag || false
    let actionId = (sourceNode.actions[0] && sourceNode.actions[0].id) || ''
    let connection = Connection.create({
      'sourceNodeId': sourceNode.id,
      'targetNodeId': targetNode.id,
      'defaultLine': flag,
      'operationType': operationType,
      'actionId': actionId
    })
    this.connections.push(connection)
  }

  delConnection (connectionId) {
    let index = this.connections.findIndex(m => m.id === connectionId)
    this.connections.splice(index, 1)
  }

  getAllNodes () {
    // 过滤不在页面展示的节点
    return this.nodes.filter(m => {
      return m.type !== 'endEvent' && m.type !== 'cancelEvent'
    })
  }

  // 删除节点
  removeNode (nodeId) {
    let node = this.nodes.find(m => m.id === nodeId)
    if (nodeId === this.startNode) {
      throw new Error('开始节点不能删除')
    }
    if (!node) {
      throw new Error('节点不存在.')
    }
    // 连接线的结束节点是要删除的节点(上面线)
    let endNodeConnections = this.connections.filter(m => m.targetNodeId === nodeId)
    // 连接线的起始节点是要删除的节点(下面线)
    let startNodeConnections = this.connections.filter(m => m.sourceNodeId === nodeId)
    endNodeConnections.forEach(m => {
      m.targetNodeId = startNodeConnections[0].targetNodeId
      // 删除节点后。操作类型也需要改变
      let node = this.nodes.find(n => n.id === m.targetNodeId)
      if (node) {
        switch (node.type) {
          case 'endEvent':
            m.operationType = 'endEvent'
            break
          case 'cancelEvent':
            m.operationType = 'cancelEvent'
            break
        }
      }
    })
    _.remove(this.connections, m => m.sourceNodeId === nodeId)
    this.nodes.splice(this.nodes.findIndex(m => m.id === nodeId), 1)
    this.connections.forEach(m => {
      // 如果通知的通知节点处理人里包括删除的节点,就把通知的节点删掉
      m.notice && m.notice.forEach(el => {
        _.remove(el.targetNode, n => n === nodeId)
      })
    })
    return node
  }

  getNode (id) {
    let node = this.nodes.find(m => m.id === id)
    if (!node) throw new Error('未找到该节点')
    return node
  }

  getConectionsById (id) {
    let connection = this.connections.find(m => m.id === id)
    if (!connection) throw new Error('未找到该流转线')
    return connection
  }

  getConectionsByNodeId (nodeId) {
    return this.connections.filter(m => m.sourceNodeId === nodeId)
  }

  // 获取当前至开始节点的所有路径
  getPaths (nodeId, path) {
    path = `${path || ''}->${nodeId}`
    let array = []
    let parentNodes = this.getParentNode(nodeId)
    if (parentNodes.length > 0) {
      let flag = true
      parentNodes.forEach(m => {
        if (!path.includes(m.sourceNodeId)) {
          flag = false
          this.getPaths(m.sourceNodeId, _.clone(path)).forEach(n => {
            array.push(`${nodeId}->${n}`)
          })
        }
        if (flag) {
          array.push(nodeId)
        }
      })
    } else {
      array.push(nodeId)
    }
    return array
  }

  // 获取上级节点 id
  getParentNode (nodeId) {
    if (this.connections) {
      return this.connections.filter(m => m.targetNodeId === nodeId)
    } else {
      return []
    }
  }
  // 获取当前节点以及之前的所有节点
  getpreviousNode (currentNodeId) {
    let nodeIds = []
    let paths = this.getPaths(currentNodeId)
    paths && paths.forEach(m => {
      m.split('->').forEach(n => {
        if (!nodeIds.includes(n)) {
          nodeIds.push(n)
        }
      })
    })
    return nodeIds
  }
  // 获取当前至结束节点的所有节点
  getNextNodes (nodeId, array) {
    let nextNodes = this.getNextNode(nodeId)
    if (nextNodes.length > 0) {
      nextNodes.forEach(m => {
        if (!array.includes(m.targetNodeId)) {
          array.push(m.targetNodeId)
          this.getNextNodes(m.targetNodeId, array)
        }
      })
    }
    return array
  }

  // 获取下级节点 id
  getNextNode (nodeId) {
    if (this.connections) {
      return this.connections.filter(m => m.sourceNodeId === nodeId)
    } else {
      return []
    }
  }

  // 节点排除网关
  getwithoutinClusiveGateway (nodes) {
    return nodes.filter(m => {
      return m.type !== 'inclusiveGateway_start' && m.type !== 'inclusiveGateway_end'
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/process/process.js